import styled from 'styled-components'

export const Tabs = styled.div`
  display: inline-flex;
  background-color: #f1f1f1;
  border-radius: 999px;
  margin: auto;
`

export const Tab = styled.button<{ $active: boolean }>`
  border: none;
  background: ${({ $active }) => ($active ? '#fff' : 'transparent')};
  box-shadow: ${({ $active }) => ($active ? '0 1px 8px 0 rgba(0, 0, 0, .32)' : 'none')};
  color: ${({ $active }) => ($active ? '#d11926' : '#161616')};
  font-weight: 600;
  padding: 8px 16px;
  font-size: 14px;
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 100px;
  text-align: center;
`
